import { render, staticRenderFns } from "./Bali.vue?vue&type=template&id=ca70a988&scoped=true&"
import script from "./Bali.vue?vue&type=script&lang=js&"
export * from "./Bali.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca70a988",
  null
  
)

export default component.exports